"use client"

import BookmarksNavButton from "@/components/layout/BookmarksNavButton"
import { DrupalMenu } from "@/components/layout/DrupalMenu"
import { MainNav } from "@/components/layout/MainNav"
import RequestAccessButton from "@/components/layout/RequestAccessButton"
import UserNavWrapper from "@/components/layout/UserNavWrapper"
import { useDrupalMenu } from "@/hooks/useDrupalMenu"
import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"
import ThemeToggle from "../ui/ThemeToggle"

export function Header() {
  const pathname = usePathname()
  const hide = pathname === "/signin" || pathname === "/signout"

  // Only fetch menu after component is mounted (post-hydration)
  // This prevents build-time errors
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  // Fetch Drupal menu client-side after hydration
  const { menuData, isLoading } = useDrupalMenu("MAIN", {
    enabled: mounted,
  })

  if (hide) return null

  return (
    <header
      className="shadow-xs sticky top-0 z-40 w-full backdrop-blur"
      role="banner"
    >
      <nav
        className="flex items-center p-2 lg:px-4 lg:py-0"
        aria-label="Main navigation"
      >
        {/* Use DrupalMenu if available, otherwise MainNav */}
        {mounted &&
        !isLoading &&
        menuData &&
        Array.isArray(menuData.items) &&
        menuData.items.length > 0 ? (
          <DrupalMenu menuData={menuData} />
        ) : (
          <MainNav />
        )}
        <div className="ml-auto flex items-center space-x-2 sm:space-x-4 relative overflow-hidden">
          <BookmarksNavButton />
          <RequestAccessButton />
          <UserNavWrapper />
          <ThemeToggle />
        </div>
      </nav>
    </header>
  )
}
